import { makeStyles } from '@material-ui/core/styles';

const adCardStyles = makeStyles((theme) => ({
  root: {
    height: '250px',
    width: '300px',
    borderRadius: '12px',
    overflow: 'hidden',
    marginBottom: '36px',
    boxShadow: theme.shadows[4],
  },
  img: {
    height: '100%',
    width: '100%',
    borderRadius: '12px',
    objectFit: 'cover'
  }
}));

export default adCardStyles;
